import dynamic from "next/dynamic";

export const ImagesCarousel = dynamic(() => import("./component"));
